/**
 * 认证状态管理
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  userId: string | null;
  nickname: string | null;
  sessionToken: string | null;
  isAuthenticated: boolean;
  
  // Actions
  setAuth: (userId: string, nickname: string, sessionToken: string) => void;
  clearAuth: () => void;
  checkAuth: () => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      userId: null,
      nickname: null,
      sessionToken: null,
      isAuthenticated: false,
      
      setAuth: (userId, nickname, sessionToken) => {
        // 统一使用内部 session token，authToken 仅用于兼容旧数据
        localStorage.setItem('session_token', sessionToken);
        localStorage.setItem('authToken', sessionToken);
        localStorage.setItem('user_id', userId);
        localStorage.setItem('nickname', nickname);
        set({
          userId,
          nickname,
          sessionToken,
          isAuthenticated: true,
        });
      },

      clearAuth: () => {
        localStorage.removeItem('authToken');
        localStorage.removeItem('session_token');
        localStorage.removeItem('user_id');
        localStorage.removeItem('nickname');
        set({
          userId: null,
          nickname: null,
          sessionToken: null,
          isAuthenticated: false,
        });
      },

      checkAuth: () => {
        // 优先检查企业微信登录的 authToken
        const authToken = localStorage.getItem('authToken');
        const sessionToken = localStorage.getItem('session_token');
        const token = authToken || sessionToken;
        const userId = localStorage.getItem('user_id');
        const nickname = localStorage.getItem('nickname');
        const isValid = !!token && !!userId;

        if (isValid && !get().isAuthenticated) {
          set({
            userId,
            nickname: nickname || null,
            sessionToken: token,
            isAuthenticated: true,
          });
        }

        return isValid;
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        userId: state.userId,
        nickname: state.nickname,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);